import MerchantList from "@/components/merchant/MerchantList";
import Footer from "@/components/store/Footer";
import LandingHeader from "@/components/store/LandingHeader";
import { FilterProvider } from "@/contexts/FilterContext";
import { redbirdLogo } from "@/constants";
import React from "react";
import { Helmet } from "react-helmet-async";

const LandingPage: React.FC = () => {
  return (
    <>
      <FilterProvider>
        <div className="min-h-screen flex flex-col">
          <Helmet>
            <title>RedBird Online Order</title>
            <link rel="icon" type="ico" href="/favicon.ico" />
          </Helmet>
          <LandingHeader />
          <main className="flex-grow">
            <MerchantList />
          </main>
          <Footer />
        </div>
      </FilterProvider>
    </>
  );
};

export default LandingPage;
